export function pair<Left, Right>(left: Left, right: Right): [Left, Right] {
  return [left, right];
}
